import React, { useEffect } from "react";
import { LoadingSpinner } from "thrive-components";
import { getAndroidAppStoreUrl, getIOSAppStoreUrl } from "../../utils/appStoreUrls";

const AppStoreRedirector = () => {

    useEffect(() => {
        const device = navigator.userAgent || navigator.vendor;

        const googlePlayUrl = getAndroidAppStoreUrl()
        const appStoreUrl = getIOSAppStoreUrl();

        const fallbackUrl = `${window.location.origin}/self-serve-onboarding`;
        
        if (/android/i.test(device)) {
            window.location.replace(googlePlayUrl);
        } else if (/iPad|iPhone|iPod|Mac OS/i.test(device)) {
            window.location.replace(appStoreUrl);
        } else {
            window.location.replace(fallbackUrl);
        }
    }, []);

    return (
        <LoadingSpinner size={10} />
    )
};

export default AppStoreRedirector;
